var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27273 0C5.76818 0 4.54545 1.22273 4.54545 2.72727C4.54545 4.23182 5.76818 5.45455 7.27273 5.45455C8.77727 5.45455 10 4.23182 10 2.72727C10 1.22273 8.77727 0 7.27273 0ZM1.81818 0.909091C0.813636 0.909091 0 1.72273 0 2.72727C0 3.73182 0.813636 4.54545 1.81818 4.54545C2.82273 4.54545 3.63636 3.73182 3.63636 2.72727C3.63636 1.72273 2.82273 0.909091 1.81818 0.909091ZM1.81818 3.63636C1.31818 3.63636 0.909091 3.22727 0.909091 2.72727C0.909091 2.22727 1.31818 1.81818 1.81818 1.81818C2.31818 1.81818 2.72727 2.22727 2.72727 2.72727C2.72727 3.22727 2.31818 3.63636 1.81818 3.63636Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRound);
export default __webpack_public_path__ + "static/media/circle-round.cf3e3f5e.svg";
export { ForwardRef as ReactComponent };